export const getPricingDetailsArray = (offering, category, label) => {
  const ps_slugs = [];
  category.pricing_structure_groups.forEach(item => {
    ps_slugs.push(
      item.pricing_structures.find(ps =>
        offering.pricing_structures.includes(ps),
      ),
    );
  });
  const pricing_details_arr = [];
  ps_slugs.forEach(slug => {
    if (slug !== undefined) {
      offering.rendered_pricing_details[slug].forEach(details => {
        if (details?.label === label) {
          pricing_details_arr.push({
            label: details?.label,
            detail: details?.detail,
          });
        }
      });
    }
  });
  return pricing_details_arr;
};

export const doesHaveDelivery = offering => {
  // "pricing_structures": [
  //       "base_per_unit_decimal",
  //       "delivery_flat_rate"
  //   ],
  return offering?.pricing_structures?.some(structure =>
    structure.includes('delivery'),
  );
};

export const extractPrice = (detail: any) => {
  if (!detail) return 'NA';
  if (detail?.includes('Accepting Offers')) return 'Accepting Offers';

  // Match patterns like "$500,000", "$150"
  const match = detail?.match(/[$¢]?([\d,]+(\.\d+)?)/);
  if (match)
    return (
      parseFloat(match[1].replace(/,/g, '')) / (detail?.includes('¢') ? 100 : 1)
    );

  // This regex is when for when there is just an amount in the detail
  const altMatch = detail?.match(/([\d,]+(\.\d+)?)/);
  if (altMatch) return parseFloat(altMatch[1].replace(/,/g, ''));

  return detail;
};
